import { ApiProperty } from "@nestjs/swagger";
import { DeheadingSample } from "../entities/deheading-sample.entity";
import { DeHeadingSampleDto } from "./deheading-sample.dto";

export class DeheadingQaQcDto {
    @ApiProperty()
    deheadingQAQCId: number;
    @ApiProperty()
    logId:number;
    @ApiProperty()
    varietyOfMaterial: number;
    @ApiProperty()
    jobNo: string;
    @ApiProperty()
    batchNo: string;
    @ApiProperty()
    sampleCode: string;
    @ApiProperty()
    hOnQty: number;
    @ApiProperty()
    hLessQty: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty({ type: [DeHeadingSampleDto] })
    deheadingSampleInfo: DeHeadingSampleDto[];
}